export const ACCOUNT_STATUS = {
  trial: { label: "TRIAL", cls: "bg-blue-500/15 text-blue-300 border-blue-500/40" },
  attivo: { label: "ATTIVO", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
  pagamento_fallito: { label: "PAGAMENTO FALLITO", cls: "bg-rose-500/15 text-rose-300 border-rose-500/40" },
  tolleranza: { label: "IN TOLLERANZA", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
  sospeso: { label: "SOSPESO", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/40" },
  cancellato: { label: "CANCELLATO", cls: "bg-zinc-700/30 text-zinc-500 border-zinc-600/40" },
};

export const PAYMENT_STATUS = {
  pagato: { label: "Pagato", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
  in_attesa: { label: "In attesa", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
  fallito: { label: "Fallito", cls: "bg-rose-500/15 text-rose-300 border-rose-500/40" },
  rimborsato: { label: "Rimborsato", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/40" },
};

export function SABadge({ map, value }) {
  const s = map[value] || { label: value || "—", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/40" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold border ${s.cls}`}
      data-testid={`badge-${value}`}>
      {s.label}
    </span>
  );
}

export const fmtD = (d) => d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const saCard = "bg-zinc-900 border border-zinc-800 rounded-lg";
export const saInput = "w-full h-11 px-3 rounded-md border border-zinc-700 bg-zinc-800 text-sm text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-amber-400";
export const saLabel = "block text-[10px] font-semibold uppercase tracking-wider text-zinc-500 mb-1";
